import React from 'react'

const Info = ({ color, ...props }) => {
  return (
    <svg
      {...props}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2427 1.75734C9.10938 0.624117 7.60266 0 6 0C4.39734 0 2.89062 0.624117 1.75734 1.75734C0.624117 2.89062 0 4.39734 0 6C0 7.60266 0.624117 9.10938 1.75734 10.2427C2.89062 11.3759 4.39734 12 6 12C7.60266 12 9.10938 11.3759 10.2427 10.2427C11.3759 9.10938 12 7.60266 12 6C12 4.39734 11.3759 2.89062 10.2427 1.75734ZM6 1.64062C6.71079 1.64062 7.28906 2.2189 7.28906 2.92969C7.28906 3.64048 6.71079 4.21875 6 4.21875C5.28921 4.21875 4.71094 3.64048 4.71094 2.92969C4.71094 2.2189 5.28921 1.64062 6 1.64062ZM7.64062 9.84375H4.35938V9.14062H5.0625V5.625H4.35938V4.92188H6.9375V9.14062H7.64062V9.84375Z"
        fill={color}
      />
    </svg>
  )
}

export default Info
